// extracted by css-extract-rspack-plugin
export default {"NativeQueryEditorContainer":"ViewNativeQueryEditor-module__NativeQueryEditorContainer___l6Gxf"};